import { ApolloCache } from "apollo-cache";
import { withClientState } from "apollo-link-state";
import { merge } from "lodash";
// import { GetAlertsQuery } from "../clientState/alerts/queries";
import {
  defaults as alertsDefaults,
  resolvers as alertsResolvers,
} from "../clientState/alerts/resolvers";
import { resolvers as demoAthleteResolvers } from "../clientState/demoAthlete/resolvers";
import { defaults as demoAthleteDefaults } from "../clientState/demoAthlete/services";

/** Create a link to handle client-only state, for alerts and menus */
export const configureLocalStateLink = (cache: ApolloCache<any>) => {
  // let data: { alerts: any } | null = null;
  // if ((process as any).browser) {
  //     try {
  //         data = cache.readQuery<{ alerts: any }>({
  //             query: GetAlertsQuery
  //         });
  //     } catch (err) {
  //         if (
  //             !err.message ||
  //             err.message.indexOf("Can't find field alerts") !== 0
  //         ) {
  //             throw err;
  //         }
  //     }
  // }

  const defaults = merge(alertsDefaults, demoAthleteDefaults, {
    alerts: undefined,
  });

  return withClientState({
    cache,
    defaults,
    resolvers: merge(alertsResolvers, demoAthleteResolvers),
  });
};



// WEBPACK FOOTER //
// ./src/client/apollo/configureApolloLocalState.tsx